import React, { type ReactNode } from 'react';
import { AxiosError } from 'axios';
import { Button } from '@wfp/ui';
import { iconAddGlyph } from '@wfp/icons';

import { useMutation, useQueryClient } from 'react-query';
import { useDocId } from '../../hooks/home';
import confirm from '../common/dialogs/Confirm';
import { createRevision } from '../../restapi/document';

import './CreateRevision.scss';


const createRevWarning = 'Although technically possible, creating Corrigendum edition must be done only if strictly necessary. Are you sure you want to proceed?';

export function CreateRevision() {
	const docId = useDocId();
	const queryClient = useQueryClient();

	// createRevision
	const createRevisionMutation = useMutation(() => createRevision(docId), {
		onSuccess: () => queryClient.invalidateQueries('doc'),
		onError: (error: AxiosError) => {
			const json: any = error.response?.data;
			const serverMsg = '' + json?.message || 'Unspecified';
			let msg: ReactNode = <p>Create revision failed with message: {serverMsg}.</p>;
			confirm({message: msg});
		},
	});
	const createRev = () => {
		confirm({message: createRevWarning, cancelLabel: 'Cancel'}).then(ok => {
			if (ok) {
				createRevisionMutation.mutate();
			}
		});
	}

	return <div className="create-revision">
		<Button kind="accent"
				icon={iconAddGlyph} iconDescription=" " iconReverse
				onClick={() => createRev()}>Corrigendum edition</Button>
	</div>;
}
